<template>
  <div>
    <!-- input解析 -->
    <DesignInput v-model="dValule" :options="options" :dModel="dModel" @input="changeValue()"
      v-if="dModel.type=='input'" />
    <DesignInputNumber v-model="dValule" :options="options" :dModel="dModel" @input="changeValue()"
      v-if="dModel.type=='number'" />
    <DesignTextarea v-model="dValule" :options="options" :dModel="dModel" v-if="dModel.type=='textarea'"
      @input="changeValue()" />
    <DesignDate v-model="dValule" :options="options" :dModel="dModel" v-if="dModel.type=='date'" @input="changeValue()">
    </DesignDate>
    <DesignSelect v-model="dValule" :options="options" :dModel="dModel" v-if="dModel.type=='select'"
      @input="changeValue()">
    </DesignSelect>
    <DesignCheckBox v-model="dValule" :options="options" :dModel="dModel" v-if="dModel.type=='checkbox'"
      @input="changeValue()">
    </DesignCheckBox>
    <DesignRadio v-model="dValule" :options="options" :dModel="dModel" v-if="dModel.type=='radio'"
      @input="changeValue()"></DesignRadio>
    <DesignDateTime v-model="dValule" :options="options" :dModel="dModel" v-if="dModel.type=='datePicker'"
      @input="changeValue()">
    </DesignDateTime>
  </div>
</template>

<script>
  export default {
    name: 'DesignFormItem',
    data() {
      return {
        searchModel: {},
        dValule: "",
      }

    },
    props: {
      dModel: {
        type: Object,
        default: function() {
          return {
            key: "",
            label: "",
            model: "",
            type: "",
            rules: []
          }
        }
      },
      options: {
        type: Object,
        default: () => {}
      },
      value: {},
    },
    components: {

    },
    watch: {
      value() {
        if (this.value && (this.value.length > 0 || typeof(this.value) == "number")) {
          this.dValule = this.value
        }
      }
    },
    methods: {
      changeValue: function() {
        this.$emit("input", this.dValule);
      }
    },
    mounted() {
      // if (this.dModel.type == "number") {
      //   console.log(this.value);
      //   console.log(typeof(this.value));
      // }

      // 获得传
      if (this.value && (this.value.length > 0 || typeof(this.value) == "number")) {
        this.dValule = this.value
      }

    }
  }
</script>
<style scoped>
  .search-design-item {
    float: left;
  }
</style>
